let mapper_options = {
  endpoint: 'twitter_accounts',
  recordClass: require('./record'),
  relations: {
    hasMany: {
      retailer: {
        localKeys: 'retailer_ids',
        localField: 'retailers'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('twitter_account', mapper_options)
}
